import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../routes";

const sectionKeys = [
  "collection",
  "usage",
  "sharing",
  "storage",
  "cookies",
  "rights",
  "retention",
  "children",
  "changes",
  "contact",
] as const;

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate(ROUTES.LOGIN, { state: { register: true } })}
          className="text-sm text-primary-40 dark:text-primary-90 hover:underline cursor-pointer font-medium"
        >
          &larr; {t("common.backToRegistration")}
        </button>
      </div>

      <h1 className="text-3xl font-bold mb-2">{t("privacyPolicy.title")}</h1>
      <p className="text-sm text-grey-50 dark:text-grey-70 mb-6">
        {t("common.lastUpdated")}: February 2026
      </p>

      <p className="mb-8 leading-relaxed">{t("privacyPolicy.intro")}</p>

      <div className="space-y-6">
        {sectionKeys.map((key) => (
          <section key={key}>
            <h2 className="text-xl font-semibold mb-2">
              {t(`privacyPolicy.sections.${key}.title`)}
            </h2>
            <p className="leading-relaxed text-grey-30 dark:text-grey-70">
              {t(`privacyPolicy.sections.${key}.content`)}
            </p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
